<template>
    <!--begin::Footer-->
    <div class="d-flex flex-center flex-column-auto p-10">
        <!--begin::Links-->
        <!--end::Links-->
    </div>
    <!--end::Footer-->
</template>
